import React, { useContext, useEffect, useState } from "react";
import Breadcrums from "../Components/Breadcrums/Breadcrums";
import ProductDisplay from "../Components/ProductDisplay/ProductDisplay";
import DescriptionBox from "../Components/DescriptionBox/DescriptionBox";
import RelatedProducts from "../Components/RelatedProducts/RelatedProducts";
import Faq from "../Components/FAQ/Faq";
import { useParams } from "react-router-dom";
import { ShopContext } from "../Context/ShopContext";
import Reviews from "../Components/CustomerReviews/Reviews";
import AddReview from "../Components/CustomerReviews/AddReview";

const Product = () => {
  const { products } = useContext(ShopContext);
  const { productId } = useParams();
  const [product, setProduct] = useState(false);

  useEffect(() => {
    setProduct(products.find((e) => e.id === Number(productId)));
  }, [products, productId]);

  return product ? (
    <div>
      <Breadcrums product={product} />
      <ProductDisplay product={product} />
      {/* <DescriptionBox/> */}
      <RelatedProducts
        category={product.category}
        subcategory={product.subcategory}
        id={product.id}
      />
      <Reviews productId={productId} />
      <Faq />
    </div>
  ) : null;
};

export default Product;
